import type { GeminiAspectRatio } from '../types'
import { GEMINI_IMAGE_ASPECT_RATIOS } from './character-config'

export const UPSCALE_PROMPT_VERSION = 'upscale-preserve-v1'

export interface ImageDimensions {
  width: number
  height: number
}

function numericAspectRatio(aspectRatio: GeminiAspectRatio): number {
  const [width, height] = aspectRatio.split(':').map(Number)
  if (!width || !height) throw new Error(`Invalid Gemini aspect ratio: ${aspectRatio}`)
  return width / height
}

/** Picks the provider ratio with the smallest proportional difference from a source image. */
export function getNearestGeminiAspectRatio({ width, height }: ImageDimensions): GeminiAspectRatio {
  if (width <= 0 || height <= 0) throw new Error('Image dimensions must be positive.')
  const sourceRatio = width / height
  return GEMINI_IMAGE_ASPECT_RATIOS.reduce((nearest, candidate) =>
    Math.abs(Math.log(numericAspectRatio(candidate) / sourceRatio)) <
    Math.abs(Math.log(numericAspectRatio(nearest) / sourceRatio))
      ? candidate
      : nearest
  )
}

/** Allows rounding noise in source dimensions while identifying exact provider ratios. */
export function isGeminiAspectRatioMatch(
  dimensions: ImageDimensions,
  aspectRatio: GeminiAspectRatio,
  tolerance = 0.005
): boolean {
  if (dimensions.width <= 0 || dimensions.height <= 0) return false
  return Math.abs(dimensions.width / dimensions.height - numericAspectRatio(aspectRatio)) <= tolerance
}
